import { render, staticRenderFns } from "./xl.vue?vue&type=template&id=060ef071&"
import script from "./xl.vue?vue&type=script&lang=js&"
export * from "./xl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports